import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsService } from '../../../../views/pages/configuration/settings/settings.service';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  private readonly v1NewMemoryStructureEndpoints = new Set([
    'loadmodel',
    'describedata',
    'droppedcolumns',
    'getContributingTags',
    'getSystemAnomalyScore',
    'oprange',
    'getalertslist',
    'topAnomalyContributors',
    'actualVsPredicted',
    'tag_average',
    'tagdata',
    'tagcorrelation',
    'savemodel',
    'state',
    'updateV2Alerts',
    'feedbackmodel',
    'feedbackalerts',
    'failurecomputation',
  ]);

  private readonly v1NewApiArchitectureEndpoints = new Set([
    'dataimport',
    'datapreprocess',
    'starttraining',
    'startprediction',
    'editmodel',
    'redeploymodel',
    'recommend_training_region',
  ]);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const settingsService = this.injector.get(SettingsService);
    const isNewMemoryStructureEnabled = settingsService.isNewMemoryStructureEnabled();
    const isNewApiArchitectureEnabled = settingsService.isNewApiArchitectureEnabled();
    // Only apply logic to pyapi endpoints && when new memory structure is enabled or new API architecture is enabled
    if ((!isNewMemoryStructureEnabled && !isNewApiArchitectureEnabled) || !request.url.includes('/pyapi/')) {
      return next.handle(request);
    }

      const urlParts = request.url.split('/');

      // Iterate through path segments to find and transform target endpoints
      for (let i = 0; i < urlParts.length; i++) {
        // Handle segments with query params (e.g. 'loadmodel?id=123' -> 'loadmodel')
        const segmentWithoutParams = urlParts[i].split('?')[0];

        if (
          (isNewMemoryStructureEnabled &&
            this.v1NewMemoryStructureEndpoints.has(segmentWithoutParams)) ||
          (isNewApiArchitectureEnabled &&
            this.v1NewApiArchitectureEndpoints.has(segmentWithoutParams))
        ) {
          // Check if the previous segment is already 'v1' to prevent duplicate prefixing
          const prevSegment = i > 0 ? urlParts[i - 1] : null;

          if (prevSegment !== 'v1') {
            const newUrlParts = [...urlParts];
            // Insert 'v1' before the target endpoint segment
            newUrlParts.splice(i, 0, 'v1');
            const transformedUrl = newUrlParts.join('/');

            return next.handle(request.clone({ url: transformedUrl }));
          }

          // If we found the endpoint but it's already prefixed, we can stop searching
          break;
        }
      }
    // Return the original request if no transformation was applied
    return next.handle(request);
  }
}
